import React from "react";
import { OrganizationClassificationCard } from "./OrganizationClassificationCard";
import { OrganizationClassificationUIProvider } from "./OrganizationClassificationUIContext";

export function OrganizationClassificationPage({ history, match }) {
  const organizationClassificationUIEvents = {
    newOrganizationClassificationButtonClick: () => {
      history.push("/admin/organizationClassification/new");
    },
    openEditOrganizationClassificationPage: id => {
      history.push(`/admin/organizationClassification/${id}/detail`);
    },
    openOrganizationClassificationFilePage: id => {
      history.push(`/admin/organizationClassification/file/${id}`);
    }
  };

  return (
    <OrganizationClassificationUIProvider
      organizationClassificationUIEvents={organizationClassificationUIEvents}
    >
      <OrganizationClassificationCard history={history} match={match} />
    </OrganizationClassificationUIProvider>
  );
}
